import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { observer } from "mobx-react-lite";
import { PriceGraph } from "../components/PriceGraph";
import { StateService } from "../services/StateService";
import { BidderTable } from '../components/BidderTable';
import { Slots } from '../components/Slots';
import { InfoBox } from '../components/InfoBox';
import backgroundImg from '../assets/auction-bg.png';
import LinearProgressBar from '../components/LinearProgressBar';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    paddingTop: '65px',
    maxWidth: '1400px',
    margin: '0 auto'
  },
  countDown: {
    width: '100%',
    color: 'white',
    borderRadius: '20px',
  },
  countDownTime: {
    width: '98%',
    margin: '0 auto',
    marginTop: '20px',
    paddingBottom: '15px',
  },
  button: {
    padding: '10px 50px',
    marginTop: '40px',
    backgroundColor: ' #4e37de',
    color: '#fff',
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: 700,
    textTransform: 'uppercase',
    borderRadius: '12px',
    fontFamily: 'Gilroy-Medium, sans-serif',
    "&:hover": {
      backgroundColor: '#3f2cb6',
    },
  },
  auctionPageTitle: {
    marginTop: 70,
    fontWeight: 500,
    fontSize: 24,
    color: '#975a92'
  },
  auctionPageInfo: {
    color: 'white',
    width: '35%',
    letterSpacing: '1px',
    fontSize: '16px',
    marginTop: '20px',
  },
  grid: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '-50px',
  },
  gridSecond: {
    marginTop: '35px',
  },
  cardSection: {
    marginTop: '0px',
    flexGrow: 1,
    width: '100%',
    position: 'relative',
  },
  graphHeading: {
    color: 'white',
    textAlign: 'left',
    paddingLeft: '40px',
    zIndex: 1,
    marginTop: '61px',
  },
  graph: {
    margin: '10px 40px 10px 0px',
    background: 'transparent'
  },
  slots: {
    margin: '0 19px 0 10px',
    textAlign: 'center',
  },
  bidders: {
    color: 'white',
    textAlign: 'left',
    paddingLeft: '19px',
    paddingRight: '19px',
    marginBottom: '10%',
    marginTop: '50px',
    paddingTop: '40px',
    position: 'relative',
  },
  leftLayout: {
    position: 'absolute',
    width: '592px',
    height: '460px',
    left: '-245px',
    top: '-239px',
    background: 'linear-gradient(199.55deg, rgba(72, 46, 95, 0.225033) 40.83%, #503045 105.46%)',
    mixBlendMode: 'normal',
    opacity: '0.9',
    filter: 'blur(135.914px)',
  },
  rightLayout: {
    position: 'absolute',
    width: '433px',
    height: '461px',
    right: '-9px',
    top: '-53px',
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
    transform: 'rotate(90deg)',
  },
  bottomLayout: {
    position: 'absolute',
    width: '331px',
    height: '209px',
    right: '-156px',
    bottom: 0,
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
  },
  innerLay: {
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  innerLay1: {
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  bottomInnerLay: {
    width: '361px',
    height: '206px',
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    position: 'absolute',
    right: '233px',
  },
  bottomInnerLay1: {
    width: '361px',
    height: '206px',
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    position: 'absolute',
    right: '157px',
    bottom: '12px',
  },
  cont: {
    marginBottom: '97px',
    zIndex: 1
  },
  slotMain: {
    zIndex: 1
  },
  slotBox: {
    width: "95%",
    borderRadius: "27px",
    background: `url(${backgroundImg}) no-repeat`,
    backgroundSize: "cover",
    padding: 40,
  },
  slot: {
    zIndex: 999,
    margin: '0 auto',
  },
  joinText: {
    fontSize: 42,
    fontFamily: "Gilroy-Regular, sans-serif",
    borderBottom: "1px solid #645d69",
    paddingBottom: 35,
    fontWeight: 400,
    marginBottom: 30,
    color: "white",
  }, 
}));

const styleTitle = {
  marginLeft: '30px',
}

interface AuctionPageProps {
  state: StateService;
}


export const AuctionPage = observer((props: AuctionPageProps) => {
  const classes = useStyles();
  let title = "AUCTION SLOTS REMAINING";

  const getProgress = (): number => {
    const availableSlots = props.state.bidStore.getAvailableSlots();
    const totalSlots = props.state.bidStore.getTotalSlots();
    if (availableSlots && totalSlots) {
      return (100 * props.state.bidStore.getAvailableSlots() / props.state.bidStore.getTotalSlots());
    }
    return 100;
  }

  return (
    <div className={classes.root}>
      <div className={classes.cardSection}>
        <Grid className={classes.cont} container style={{ position: 'relative' }}>
        <Grid item xs={6} className={classes.slot}>
         <Paper elevation={0} className={classes.slotBox}>
           <Typography
             gutterBottom
             variant="h5"
             component="h2"
             className={classes.joinText}
           >
             {title}
           </Typography>
           <LinearProgressBar
          progress={getProgress()}
          title={`${props.state.bidStore.getAvailableSlots()} Slots`} />
         </Paper>
       </Grid>
          <div className={classes.leftLayout}></div>
          <div className={classes.rightLayout}>
            <div className={classes.innerLay}>
            </div>
            <div className={classes.innerLay1}>
            </div>
          </div>
          <Grid item container xs={12} className={classes.graphHeading}>
            <Grid item xs={8}>
              <Typography gutterBottom variant="h5" component="h2" className="secTitle">
                Auction Price Schedule
                <InfoBox
                  title="This graph shows the scheduled price of the auction. The price starts high and steadily
                  decreases. But the slots might sell out before the reserve price is reached. Each time is an estimate
                  based on the block height for that price."
                />
              </Typography>
              <Paper elevation={0} className={classes.graph}>
                <PriceGraph state={props.state} />
              </Paper>
            </Grid>
            <Grid item xs={4} className={classes.slotMain}>
              <Grid item xs={12} className={classes.slots}>
                <Slots state={props.state} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.bidders}>
            <Grid container>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Typography gutterBottom variant="h5" component="h2" className="secTitle" style={styleTitle}>
                    { props.state.bidStore.isBiddingPhase() && props.state.rounds.isAuctionPhase()
                        ? ("Bidders")
                        : ("Successful Bidders")
                    }
                    <InfoBox
                      title="This table shows the addresses that have placed bids in the auction. Also shown are the
                      predicted slots for each bidder (if the auction is still running) or the
                      finalised slots (if the auction has ended)."
                    />
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <BidderTable state={props.state} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.bottomLayout}>
          <div className={classes.bottomInnerLay}></div>
          <div className={classes.bottomInnerLay1}></div>
        </div>
      </div>
    </div>
  );
});
